// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 11) return "static/js/c6b172e75b65ebbf40dc.bundle.js";
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"42":"f57b15d5c829a868fd0a","132":"8e98fb3355f4849b19d0","133":"e1a8116c78066cbd2a08"}[chunkId] + ".chunk.js";
};